import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  inputRoot: {
    '&::before': {
      border: 0
    },
    '&:hover': {
      '&::before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)'
      }
    }
  },
  input: {
    fontSize: '13px',
    color: '#717171'
  }
});

export default useStyles;
